import React from "react";
import BannerContainer from "../../../Containers/BannerContainer";
import PromoBox from "../PromoBox";

import styled from "styled-components";
// import RecentPlaylists from "~/Components/SideNav/RecentPlaylists";
import Store from "~/Components/Features/Store";
import Store2 from "~/Components/Features/Store2";
import ShufflePromo from "~/Components/Features/ShufflePromo";
// import Interviews from "~/Components/SideNav/Interviews";

export const PromoBoxWrapper = styled.section`
  h3 {
    margin-bottom: 12px;
    margin-bottom: 20px;
    text-align: center;
  }
`;

const MessageBoardRightNav = () => {
  return (
    <React.Fragment>

      {/* <RecentPlaylists limit={4} /> */}

      <div className="mb-feature-box">
        <Store />
      </div>
      <div className="mb-feature-box">
        <Store2 />
      </div>

      {/* <PromoBoxWrapper>
        <h3>Interviews</h3>
        <Interviews />
      </PromoBoxWrapper> */}
      {/* <ShufflePromo paddingTop="20px" paddingBottom="30px" /> */}

      <PromoBoxWrapper>
        <h3>DC Promo Tracks</h3>
        <BannerContainer
          type="promo"
          render={({ banner: promoTrackBanners }) =>
            promoTrackBanners.map((promoTrackBanner) => <PromoBox key={promoTrackBanner.id} id="promo" promoTrack={promoTrackBanner} />)
          }
        />
      </PromoBoxWrapper>
    </React.Fragment>
  );
};

export default MessageBoardRightNav;
